const tracking = {
    orderStatus: {
        orderPlaced: {
            title: "Order Placed",
            subTitle: "We have received your order"
        },
        onTheWay: {
            title: "Flame-grilling & cooking",
            subTitle: "Grill and cooking"
        },
        orderCompleted: {
            title: "Order is completed",
            subTitle: "Enjoy your meal"
        },
        cooking: {
            title: "Flame-grilling & cooking",
            subTitle: "Grill and cooking"
        },
        readyPickup: {
            title: "Order is completed",
            subTitle: "Enjoy your meal"
        },
        canceled: {
            title: "Canceled",
            subTitle: "{0}"
        }
    },
    contactCallcenter: "Contact 1112",
}

const delivery = {
    statusText: {
        onGoing: "Ongoing",
        completed: "Completed"
    }
}

export const myOrder = {
    tracking,
    delivery,

    title: 'My Order',
    ongoing: 'Ongoing',
    order_history: 'Order History',


    popupTitle: "Details",
    orderNo: "Order No : ",
    orderNoLabel: "Order No.",
    orderType: "Order Type",
    orderTypeText: {
        delivery: "Delivery",
        takeaway: "Takeaway",
        dinein: "Dine in",
        subscription: "Subscription Plan"
    },
    
    estimateTime: "Estimate Time",
    status: "Status",
    orderSummary: "Order Summary",
    moreDetail: "More Details",
    lessDetail: "Less",
    paymentDetails: "Payment Details",
    cash: "Cash",
    credit: "Credit card",
    linepay: "Rabbit LINE Pay",
    truewallet: "TrueMoney Wallet",
    promptpay: "PromptPay",

    subTotal: "Subtotal",
    deliveryFee: "Delivery Fee",
    discount: "Discount",
    total: "Total",
    except: "Except",
    bath: "Baht",

    freeGift: 'Free Gift!',
    awesome: 'Awesome!',

    history: {
        order_no: "Order No :",
        order_on: "Order on :",
        total: "Total :",
        bath: "Baht",
        status: "Status :",
        reorder: "Re-Order",
    },

    search_placeholder: "Order no. or Phone no.",

    statusOrderPlaced: "Order Place",
    statusOnRoute: "Ongoing",
    statusOrderComplete: "Complete",
    statusReadyToPick: "Finish Cooking",
    statusPickedUp: "Picked Up",
    statusCanceled: "Cancel",

    please_wait: "Thank you for your order!",
    status_ordersubscription_complete: "Complete",
}

export default myOrder
